export function createIdentifierFromQuery(query: string): string {
	// Early return for empty input
	const trimmed = query.trim();
	if (!trimmed) {
		return '';
	}

	return (
		trimmed
			// Remove comments first, then normalize whitespace
			.replace(/#[^\r\n]*/g, '')
			.replace(/\s+/g, ' ')
			// Remove operation names
			.replace(/\b(query|mutation|subscription)\s+[A-Za-z_][A-Za-z0-9_]*\s*([({])/g, '$1$2')
			// Clean up spacing around punctuation and keywords
			.replace(
				/\s*([{}():,])\s*|\b(query|mutation|subscription)\s+([({])/g,
				(_, punct, op, bracket) => punct || op + bracket,
			)
			// Handle fragment spacing
			.replace(/\bfragment\s+([A-Za-z_][A-Za-z0-9_]*)\s+on\s+/g, 'fragment $1 on ')
			.trim()
	);
}
